import { Controller } from '@hotwired/stimulus';
const controller = class extends Controller {
    constructor(context) {
        super(context);
        this.__stimulusLazyController = true;
    }
    initialize() {
        if (this.application.controllers.find((controller) => {
            return controller.identifier === this.identifier && controller.__stimulusLazyController;
        })) {
            return;
        }
        import('/home/justifit-moncompte-fr/htdocs/moncompte.justifit.fr/releases/2026-11-05-10-36-56-v3.65.0/assets/controllers/date_placeholder_controller.js').then((controller) => {
            this.application.register(this.identifier, controller.default);
        });
    }
};
export { controller as default };